module.exports = {"TXTWCL_EW":{"id":"TXTWCL_EW","defaultMessage":"V/P"},"TXTWCL_Single":{"id":"TXTWCL_Single","defaultMessage":"Singel","ontario":"Singel"}}